import firebase from 'firebase'
import 'firebase/firestore'


const firebaseConfig = {
  apiKey: "AIzaSyDbKdWDiv3NVXzCGpu4slNnEnv7VHB7ZjE",
  authDomain: "phoeshons-6d734.firebaseapp.com",
  databaseURL: "https://phoeshons-6d734.firebaseio.com",
  projectId: "phoeshons-6d734",
  storageBucket: "phoeshons-6d734.appspot.com",
  messagingSenderId: "20600092196",
  appId: "1:20600092196:web:23eb19c82c7a2503654ab1",
  measurementId: "G-NK026VED9N"
};

const fb = firebase.initializeApp(firebaseConfig);

export default fb;